// BUSINESS("商业险"), COMPEL("交强险"), CARRIER_LIABILITY_INSURANCE("承运人责任险")
var policyTypeOptions = [
    {
        label: '交强险',
        val: 'COMPEL',
    },
    {
        label: '商业险',
        val: 'BUSINESS',
    },
    {
        label: '承运人责任险',
        val: 'CARRIER_LIABILITY_INSURANCE',
    },
];
// 承保、批改、退保
// UNDERWRITE("承保"), CORRECT("批改"), CANCEL("退保");
var policyOperOptions = [
    {
        label: '承保',
        val: 'UNDERWRITE',
    },
    {
        label: '批改',
        val: 'CORRECT',
    },
    {
        label: '退保',
        val: 'CANCEL',
    },
];
export { policyTypeOptions, policyOperOptions };
